import React, { useContext } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { DeviceSection } from "../../context/DeviceContext";
import { useTranslation } from "react-i18next";
const DeviceInfo = () => {
  const { t } = useTranslation();
  const { ShowHideDeviceFunction } = useContext(DeviceSection);
  const initialValues = {
    name: "",
    type: "",
    home: "",
    room: "",
  };

  const submitForm = () => {
    ShowHideDeviceFunction("allDevices");
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(t("نام دستگاه را وارد کنید.")),
    type: Yup.string().required(t("نوع دستگاه را وارد کنید.")),
    home: Yup.string().required(t("نام خانه را وارد کنید.")),
    room: Yup.string().required(t("نام اتاق را وارد کنید.")),
  });

  return (
    <>
      <div className="deviceDetailsImg text-center pt-2 mt-3 mx-auto">
        <span className="rounded-circle mx-auto d-block">
          <i className="icon-lump"></i>
        </span>
        <p className="m-0">{t("لامپ")}</p>
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        {(props) => (
          <Form>
            <div className="my-4">
              <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                {props.values.name && (
                  <p className="fn12 m-0 text-right">{t("نام دستگاه")}</p>
                )}
                <input
                  type="text"
                  placeholder={t("نام دستگاه")}
                  name="name"
                  className="w-100 text-center fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="name">
                {(errMsg) => (
                  <div className="text-danger text-right fn10 mt-1">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="my-4">
              <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                {props.values.type && (
                  <p className="fn12 m-0 text-right">{t("نوع دستگاه")}</p>
                )}
                <input
                  type="text"
                  placeholder={t("نوع دستگاه")}
                  name="type"
                  className="w-100 text-center fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="type">
                {(errMsg) => (
                  <div className="text-danger text-right fn10 mt-1">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="my-4">
              <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                {props.values.home && (
                  <p className="fn12 m-0 text-right">{t("خانه")}</p>
                )}
                <input
                  type="text"
                  placeholder={t("خانه")}
                  name="home"
                  className="w-100 text-center fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="home">
                {(errMsg) => (
                  <div className="text-danger text-right fn10 mt-1">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="my-4">
              <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                {props.values.room && (
                  <p className="fn12 m-0 text-right">{t("اتاق")}</p>
                )}
                <input
                  type="text"
                  placeholder={t("اتاق")}
                  name="room"
                  className="w-100 text-center fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="room">
                {(errMsg) => (
                  <div className="text-danger text-right fn10 mt-1">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="my-4">
              <p className="fn12 text-right">{t("انتخاب آیکون")}</p>
              <span className="selectIcon d-block"></span>
            </div>
            <div className="d-flex flex-wrap justify-content-center mt-5">
              <button
                type="submit"
                className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
              >
                <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
                <small className="fn12 mt-1">{t("بعدی")}</small>
              </button>
              <div
                className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                onClick={() => ShowHideDeviceFunction("scanDevice")}
              >
                <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
                <small className="fn12 mt-1">{t("بازگشت")}</small>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export { DeviceInfo };
